import { type AxiosInstance, HttpStatusCode, isAxiosError } from "axios";
import { SendToTrackingService } from "@/api/handlers/errors";
import { type PlotRequestDetailResponse } from "@/features/map/types";

/**
 * プロット情報詳細を取得するAPI
 *
 * @param {AxiosInstance} apiClient - axios
 * @param {number} id - プロットリクエストID
 * @returns {Promise<PlotRequestDetailResponse | undefined>}
 */
export const getPlotRequestDetailAPI = async (
  apiClient: AxiosInstance,
  id: number
): Promise<PlotRequestDetailResponse | undefined> => {
  try {
    const response = await apiClient.get<PlotRequestDetailResponse>(
      `/map/plot-request/${id}`
    );

    return response.status === HttpStatusCode.Ok ? response.data : undefined;
  } catch (error) {
    if (
      isAxiosError(error) &&
      (error.response?.status ?? HttpStatusCode.InternalServerError) >=
        HttpStatusCode.InternalServerError
    ) {
      SendToTrackingService(error);
    }
    throw error;
  }
};
